export var Name = 'share-content';
export var ShareContentEvent = Name;